import { Link } from 'react-router-dom'
import { useMyLoot } from '@/hooks/queries'
import { cn } from '@/lib/cn'
import type { Giveaway } from '@/models/giveaway'
import { KeyStrip } from '../KeyStrip'

interface WonKeyPanelProps {
  giveaway: Giveaway
  className?: string
  /** Called when following the link to My Loot, e.g. to close a modal. */
  onNavigate?: () => void
}

/** Shown on a giveaway the signed-in user has won a key from. */
export function WonKeyPanel({ giveaway, className, onNavigate }: WonKeyPanelProps) {
  const { data: loot = [] } = useMyLoot()
  if (giveaway.id === null) return null

  const won = loot.filter((prize) => prize.giveaway_id === giveaway.id)
  if (won.length === 0) return null

  return (
    <section className={cn('won-key-panel', className)} aria-label="Your prize">
      <div className="won-key-heading">
        <span className="won-key-badge">You won</span>
        <span className="won-key-title">
          {won.length === 1
            ? 'Your key from this giveaway'
            : `Your ${won.length} keys from this giveaway`}
        </span>
      </div>
      {won.map((prize) => (
        <KeyStrip key={prize.id ?? prize.key} value={prize.key} title={prize.title} />
      ))}
      <Link className="won-key-link" to="/my/loot" onClick={onNavigate}>
        All your loot
      </Link>
    </section>
  )
}
